import { useState, useCallback } from "react";
import {
  DuplicateDecision,
  ExistingInquiryLite,
  SubmitInquiryInput,
} from "./useSubmitInquiry";

export function useDuplicateDialog() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [existing, setExisting] = useState<ExistingInquiryLite | null>(null);
  const [input, setInput] = useState<SubmitInquiryInput | null>(null);
  const [resolver, setResolver] = useState<((decision: DuplicateDecision) => void) | null>(null);

  const onDuplicate = useCallback(
    (existingInquiry: ExistingInquiryLite, inputData: SubmitInquiryInput) => {
      return new Promise<DuplicateDecision>((resolve) => {
        setExisting(existingInquiry);
        setInput(inputData);
        setResolver(() => resolve);
        setDialogOpen(true);
      });
    },
    []
  );

  const handleDecision = useCallback((decision: DuplicateDecision) => {
    setDialogOpen(false);
    if (resolver) {
      resolver(decision);
      setResolver(null);
    }
  }, [resolver]);

  const handleClose = useCallback(() => {
    handleDecision("cancel");
  }, [handleDecision]);

  return {
    dialogOpen,
    existing,
    input,
    onDuplicate,
    handleDecision,
    handleClose,
  };
}


